import { render, staticRenderFns } from "./ColorEdit.vue?vue&type=template&id=e2871258&scoped=true&"
import script from "./ColorEdit.vue?vue&type=script&lang=js&"
export * from "./ColorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2871258",
  null
  
)

export default component.exports